// extracted by mini-css-extract-plugin
export default {"modal":"NavigationModal__modal--slots-rU7F9","overlay":"NavigationModal__overlay--slots-NTtKJ","scrollbar":"NavigationModal__scrollbar--slots-fnOJz"};